import axios from 'axios';

const NavService = {
    cachedList: [],
    cachedTime: 0,
    getList: function (request, updateTime = null) {
        var self = this;

        //check local storage
        var time = parseInt(localStorage.getItem("lthub_cached_nav_time"));
        if (time && time > self.cachedTime) {
            self.cachedTime = time;
            var entries = localStorage.getItem("lthub_cached_nav");
            if (entries)
                self.cachedList = JSON.parse(entries);
            if (entries) {
                try {
                    self.cachedList = JSON.parse(entries);
                } catch (e) {
                    self.cachedList = null;
                }
            }
        }

        if (typeof updateTime == "string")
            updateTime = parseInt(updateTime);

        //if current version is old than timestamp from settings
        if (updateTime === null || updateTime > self.cachedTime || !self.cachedList || self.cachedList.length == 0) {
            return axios.get("api/nav", { params: request }, { withCredentials: true })
                .then((response) => {
                    self.cachedTime = updateTime;
                    self.cachedList = response.data.data;
                    localStorage.setItem("lthub_cached_nav", JSON.stringify(self.cachedList));
                    localStorage.setItem("lthub_cached_nav_time", self.cachedTime + "");
                    return self.cachedList;
                });
        } else {
            return new Promise((resolve, reject) => {
                resolve(self.cachedList);
            });
        }
    },
    update: (request) => {
        return axios.put("api/nav", request, { withCredentials: true });
    }
};

export default NavService;